/* global Stripe */

import config from '../config'

export default {
    init,
    initCard,
    createCardToken,
}

let stripe = null

function init() {
    stripe = Stripe(config.StripePublicKey)
}

function initCard(selector) {
    const elements = stripe.elements()

    const card = elements.create('card')
    card.mount(selector)

    return card
}

async function createCardToken(card) {
    try {
        const {
            token,
            err
        } = await stripe.createToken(card)
        if (err) {
            return {
                err: err.message
            }
        }
        if (!token) {
            return {
                err: 'Unknown error'
            }
        }

        return {
            token: token.id
        }
    } catch (err) {
        return {
            err: err
        }
    }
}